module.exports = __webpack_public_path__ + "img/teaser_richy2.37da88f8.jpg";